// src/pages/GalleryPage.js
import React from 'react';
import '../styles/GalleryPage.css';
import Footer from '../components/Footer';

import dish1  from '../assets/dish1.jpg';
import dish2  from '../assets/dish2.jpg';
import dish3  from '../assets/dish3.jpg';
import dish4  from '../assets/dish4.jpg';
import dish5  from '../assets/dish5.jpg';
import dish6  from '../assets/dish6.jpg';
import dish7  from '../assets/dish7.jpg';
import dish8  from '../assets/dish8.jpg';
import dish9  from '../assets/dish9.jpg';
import dish10 from '../assets/dish10.jpg';
import dish11 from '../assets/dish11.jpg';
import dish12 from '../assets/dish12.jpg';
import dish13 from '../assets/dish13.jpg';
import dish14 from '../assets/dish14.jpg';
import dish15 from '../assets/dish15.jpg';
import dish16 from '../assets/dish16.jpg';
import dish17 from '../assets/dish17.jpg';
import dish18 from '../assets/dish18.jpg';

const IMAGES = [
  dish1,  dish2,  dish3,  dish4,  dish5,  dish6,
  dish7,  dish8,  dish9,  dish10, dish11, dish12,
  dish13, dish14, dish15, dish16, dish17, dish18,
];

const GalleryPage = () => (
  <div className="gallery-page">
    <header className="gallery-page__header">
      <span className="gallery-page__eyebrow">A Taste in Every Frame</span>
      <h1 className="gallery-page__title">Gallery</h1>
      <hr className="gold-divider gold-divider--center" />
    </header>

    <div className="gallery-grid">
      {IMAGES.map((img, i) => (
        <div key={i} className="gallery-item">
          <img
            src={img}
            alt={`Lebua Thai dish ${i + 1}`}
            loading="lazy"
          />
        </div>
      ))}
    </div>

    <Footer />
  </div>
);

export default GalleryPage;
